import { z } from 'zod';

// ---------------------------------------------------------------------------
// Download
// ---------------------------------------------------------------------------

export const downloadBody = z.object({
  type: z.enum(['workspace', 'agent_instructions']),
  agent_id: z.string().uuid().optional(),
  organization_name: z.string().optional(),
});

// ---------------------------------------------------------------------------
// Upload
// ---------------------------------------------------------------------------

export const uploadQuery = z.object({
  type: z.enum(['agent_instructions']),
  agent_id: z.string().uuid(),
  hub_id: z.string().uuid(),
});

// ---------------------------------------------------------------------------
// Sign URL
// ---------------------------------------------------------------------------

export const signUrlBody = z.object({
  bucket: z.string(),
  filePath: z.string(),
  expiresIn: z.number().int().positive().optional(),
});

// ---------------------------------------------------------------------------
// Inferred types
// ---------------------------------------------------------------------------

export type DownloadBody = z.infer<typeof downloadBody>;
export type UploadQuery = z.infer<typeof uploadQuery>;
export type SignUrlBody = z.infer<typeof signUrlBody>;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

/** Shared base for all download responses */
interface DownloadResponseBase {
  success: true;
  download_url: string;
  expires_in: number;
}

/** POST /download (type=workspace) */
export interface DownloadWorkspaceResponse extends DownloadResponseBase {
  summary: {
    organization?: string;
    organizations?: number;
    hubs: number;
    files: number;
  };
}

/** POST /download (type=agent_instructions) */
export interface DownloadAgentInstructionsResponse extends DownloadResponseBase {
  summary: { files: number };
}

/** Union of all download responses */
export type DownloadResponse =
  | DownloadWorkspaceResponse
  | DownloadAgentInstructionsResponse;

/** POST /upload */
export interface UploadResponse {
  success: true;
  file_id: string;
  file_path: string;
}

/** POST /sign */
export interface SignUrlResponse {
  signedUrl: string;
}
